

import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

const Surgeries = () => {
  const [showAll, setShowAll] = useState(false);
  const navigate = useNavigate();

  const surgeries = [
    { name: "Piles Treatment", path: "/piles", img: "https://img.icons8.com/color/96/stomach.png" },
    { name: "Anal Fistula", path: "/fistula", img: "https://img.icons8.com/color/96/doctor-male.png" },
    { name: "Anal Fissure", path: "/fissure", img: "https://img.icons8.com/color/96/document.png" },
    { name: "Kidney Stone (RIRS)", path: "/rirs", img: "https://img.icons8.com/color/96/kidney.png" },
    { name: "Hydrocele", path: "/hydrocele", img: "https://img.icons8.com/color/96/male.png" },
    { name: "Gynecology", path: "/gynecology", img: "https://img.icons8.com/color/96/pregnant.png" },
    { name: "Cosmetic Surgery", path: "/aesthetics", img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcS7MtLLoGu4WCuAClTUm2C5fQi3zY85FrXipg&s" },
    { name: "Laparoscopy", path: "/laparoscopy", img: "https://img.icons8.com/color/96/surgery.png" },

    // ✅ FIXED ROUTE
    { name: "Laser Circumcision", path: "/laser-circumcision", img: "https://img.icons8.com/color/96/laser-beam.png" },

    { name: "URSL Stone Removal", path: "/ursl", img: "https://img.icons8.com/color/96/kidney.png" },
    { name: "PCNL Surgery", path: "/pcnl", img: "https://img.icons8.com/color/96/kidney.png" },
    { name: "Septoplasty", path: "/septoplasty", img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTUZt-mbVxJXTlO7Uh9aostybPMgSSf6gl2hg&s" },

    { name: "Tonsillectomy", path: "/tonsillectomy", img: "https://img.icons8.com/color/96/throat.png" },
    { name: "Gynecomastia", path: "/gynecomastia", img: "https://img.icons8.com/color/96/breast.png" },
    { name: "Lipoma Removal", path: "/lipoma", img: "https://img.icons8.com/color/96/skin.png" },
    { name: "MTP", path: "/mtp", img: "https://img.icons8.com/color/96/abortion.png" },
    { name: "Orthopedic", path: "/orthopedics", img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSjT_EIUQhrqKmpcn1O_4pru8yP5EqNH_MaaQ&s" },
    { name: "ENT Care", path: "/ent", img: "https://thumbs.dreamstime.com/b/ear-vector-icon-symbol-human-listen-hear-line-167569870.jpg" },
    { name: "Thyroid", path: "/thyroidectomy", img: "https://www.shutterstock.com/image-vector/thyroid-icon-isolated-throat-line-260nw-1592440381.jpg" },

    // ✅ FIXED ROUTE
    { name: "Knee Replacement", path: "/knee-replacement", img: "https://img.icons8.com/color/96/leg.png" },

    // ✅ FIXED ROUTE
    { name: "Male Fertility", path: "/male-fertility", img: "https://img.icons8.com/color/96/test-tube.png" },

    { name: "Hysterectomy", path: "/hysterectomy", img: "https://img.icons8.com/color/96/uterus.png" },
  ];

  const visible = showAll ? surgeries : surgeries.slice(0, 6);

  useEffect(() => {
    const style = document.createElement("style");

    style.innerHTML = `
    .surgeries{
      background: linear-gradient(135deg, #6a00f4, #9c27b0);
      padding:60px 20px;
    }

    .container{
      max-width:1200px;
      margin:auto;
    }

    .grid{
      display:grid;
      grid-template-columns:repeat(6,1fr);
      gap:20px;
    }

    .card{
      background:#fff;
      border-radius:18px;
      padding:18px;
      text-align:center;
      cursor:pointer;
      transition:0.3s;
      box-shadow:0 6px 15px rgba(0,0,0,0.1);
    }

    .card:hover{
      transform:translateY(-6px) scale(1.03);
    }

    .icon{
      width:70px;
      height:70px;
      margin:auto;
      display:flex;
      align-items:center;
      justify-content:center;
      background:#f3f3f3;
      border-radius:50%;
    }

    .icon img{
      width:40px;
      height:40px;
    }

    .name{
      font-size:13px;
      font-weight:600;
      margin-top:10px;
      color:#333;
    }

    .btn{
      margin-top:30px;
      padding:12px 28px;
      border:none;
      border-radius:30px;
      background:#ff7a00;
      color:#fff;
      display:block;
      margin-left:auto;
      margin-right:auto;
      cursor:pointer;
      font-weight:600;
    }

    @media(max-width:900px){
      .grid{grid-template-columns:repeat(3,1fr);}
    }

    @media(max-width:500px){
      .grid{grid-template-columns:repeat(2,1fr);}
    }
    `;

    document.head.appendChild(style);
  }, []);

  return (
    <section className="surgeries">
      <div className="container">

        <div className="grid">
          {visible.map((item, i) => (
            <div
              key={i}
              className="card"
              onClick={() => navigate(item.path)}
            >
              <div className="icon">
                <img src={item.img} alt={item.name} />
              </div>
              <div className="name">{item.name}</div>
            </div>
          ))}
        </div>

        <button className="btn" onClick={() => setShowAll(!showAll)}>
          {showAll ? "View Less" : "View More"}
        </button>

      </div>
    </section>
  );
};

export default Surgeries;